import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import ErrorDialog from '../../components/ErrorDialog';
import SuccessDialog from '../../components/SuccessDialog';
import LayoutContainer from '../../containers/Layout';

//- Pages / Route
import BulkFormula from './BulkFormula';
import BulkInvoice from './BulkInvoice';
import BulkLcfsTransfer from './BulkLcfsTransfer';
import Formula from './Formula';
import StationInvoice from './StationInvoice';
import TrueUpInvoice from './TrueUpInvoice';

//- XXX eventually bulk invoice

const styles = () => {
	return {};
};

const NoMatch = () => (
	<div>
		<h2>Invalid URL. Please check your URL or contact marketing@pearsonfuels.com</h2>
	</div>
);

class PrintableLayout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isSuccessDialogOpen: false,
			isErrorDialogOpen: false,
		};
		this.handleSuccessClose = this.handleSuccessClose.bind(this);
	}

	handleSuccessClose() {
		this.props.clearSuccess();
		this.props.history.push(this.props.onSuccessRedirectTo);
	}

	render() {
		const { classes, successMessages = [], errorMessages = [] } = this.props;

		const isSuccessDialogOpen = successMessages.length !== 0;
		const isErrorDialogOpen = errorMessages.length !== 0;

		return (
			<div className={classes.root}>
				<Switch>
					<Route
						exact
						path="/printable/stationInvoice/:stationInvoiceId/:securityHash"
						component={StationInvoice}
					/>
					<Route
						exact
						path="/printable/bulkInvoice/:bulkInvoiceId/:securityHash"
						component={BulkInvoice}
					/>

					<Route
						exact
						path="/printable/trueUpInvoice/:trueUpInvoiceId/:securityHash"
						component={TrueUpInvoice}
					/>

					<Route
						exact
						path="/printable/stationInvoiceFormula/:stationInvoiceId/:securityHash"
						component={Formula}
					/>

					<Route
						exact
						path="/printable/bulkInvoiceFormula/:bulkInvoiceId/:securityHash"
						component={BulkFormula}
					/>

					<Route
						exact
						path="/printable/bulkLcfsTransfer/:bulkInvoiceId/:securityHash"
						component={BulkLcfsTransfer}
					/>

					<Route component={NoMatch} />
				</Switch>

				<ErrorDialog
					onClose={this.props.clearError}
					errorMessages={errorMessages}
					open={isErrorDialogOpen}
				/>

				<SuccessDialog
					onClose={this.handleSuccessClose}
					successMessages={successMessages}
					open={isSuccessDialogOpen}
				/>
			</div>
		);
	}
}

PrintableLayout.propTypes = {
	classes: PropTypes.object.isRequired,
	onSuccessRedirectTo: PropTypes.string,
	successMessages: PropTypes.array,
	errorMessages: PropTypes.array,
	clearError: PropTypes.func,
	clearSuccess: PropTypes.func,
	history: PropTypes.object,
};

export default _.flow([withStyles(styles), LayoutContainer])(PrintableLayout);
